/** @prettier */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getActiveMultiples } from '@xanadu/ui-shared/modules/multiples/actions';

import ActiveView from '../../../components/Multiples/ActiveView';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getActiveMultiples,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    activeMultiples: state.getIn(['multiples', 'actives']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    activeMultiplesError: state.getIn(['multiples', 'activesError']),
    loadingMultiples: state.getIn(['multiples', 'loadingActiveMultiples']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveView);
